<template>
  <div>NotificacionesHistoricas</div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export class NotificacionesHistoricas extends Vue {}
export default NotificacionesHistoricas;
</script>
